import React, { type FC, useState } from "react";
import * as Styles from "./styles/PromotionBannerStyles";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import type { ModelFilterPromotioBannerConfigType } from "../../../server/AEMModelFilterSettingsTypes";
import { getAemImageUrl } from "../../../../../../common-deprecated/utils";
import { useModelFilterLabel } from "../../../utils/labels";

const PromotionBanner: FC<{ promotionBannerConfig: ModelFilterPromotioBannerConfigType }> = ({
    promotionBannerConfig,
}): JSX.Element => {
    const { title, description, linkLabel, linkUrl, bannerUrl, bannerAltTag, defaultOpen } = promotionBannerConfig;
    const [bannerOpen, setBannerOpen] = useState(defaultOpen);
    const showOfferLabel = useModelFilterLabel("modelfilterShowPromotionBanner");
    const hideOfferLabel = useModelFilterLabel("modelfilterHidePromotionBanner");

    return (
        <Styles.BannerContainer>
            <Styles.ShowHideButton
                aria-controls="promotionBannerId"
                aria-expanded={bannerOpen}
                open={bannerOpen}
                onClick={() => {
                    setBannerOpen(!bannerOpen);
                }}
            >
                <IconWrapper aria-hidden="true">
                    <Icon variant={bannerOpen ? "minus" : "plus"} />
                </IconWrapper>
                <Text.Button>{bannerOpen ? hideOfferLabel : showOfferLabel}</Text.Button>
            </Styles.ShowHideButton>
            <Styles.BannerContent id="promotionBannerId" open={bannerOpen}>
                {bannerOpen ? (
                    <>
                        <Styles.BannerImageFigure>
                            <Styles.BannerImage
                                src={getAemImageUrl(bannerUrl, { fit: "wrap", wid: 1200, hei: 700, fmt: "png-alpha" })}
                                alt={bannerAltTag ?? title}
                            />
                        </Styles.BannerImageFigure>

                        <Styles.BannerText open={bannerOpen}>
                            <Styles.BannerTitle open={bannerOpen}>{title}</Styles.BannerTitle>
                            <Styles.BannerDescription>{description}</Styles.BannerDescription>
                            <Button.Primary as="a" href={linkUrl} m={0}>
                                <Text.Button>{linkLabel}</Text.Button>
                            </Button.Primary>
                        </Styles.BannerText>
                    </>
                ) : (
                    <>
                        <Styles.BannerText open={bannerOpen}>
                            <Styles.BannerTitle open={bannerOpen}>{title}</Styles.BannerTitle>
                        </Styles.BannerText>
                    </>
                )}
            </Styles.BannerContent>
        </Styles.BannerContainer>
    );
};

export default PromotionBanner;
